// Static content for AllAboutYouBuy — swap freely without touching UI code.

export const BRAND = {
    name: "AllAboutYouBuy",
    tagline: "Find it. Love it. Buy it.",
    description:
        "Hand-tested product recommendations, honest reviews and beginner-friendly buying guides — everything worth buying, curated in one place.",
    founder: "The AllAboutYouBuy Team",
    email: "hello@launchtoearn.com",
    youtubeHandle: "@Catniverse24",
    socials: {
        youtube: "https://www.youtube.com/@Catniverse24",
        instagram: "https://www.instagram.com/launchtoearn33/",
    },
};

export const NAV = [
    { label: "Home", to: "/" },
    { label: "AI Tools", to: "/ai-tools" },
    { label: "Picks", to: "/affiliate" },
    { label: "Shorts", to: "/shorts" },
    { label: "Blog", to: "/blog" },
    { label: "Free eBooks", to: "/ebooks" },
    { label: "Shop", to: "https://superprofile.bio/launchtoearn", external: true },
    { label: "About", to: "/about" },
    { label: "Contact", to: "/contact" },
];

export const TESTIMONIALS = [
    {
        name: "Priya M.",
        role: "New reader, Mumbai",
        quote: "The 25 Ideas eBook is the first free guide I've read that didn't feel like a sales pitch. Actually useful.",
        rating: 5,
    },
    {
        name: "Rahul S.",
        role: "College student, Bengaluru",
        quote: "Finally a shopping guide that tells me what's actually worth buying — saved me from three bad purchases already.",
        rating: 5,
    },
    {
        name: "Ananya K.",
        role: "Shopper, Delhi",
        quote: "Their honest reviews cut through the Amazon noise. The tumbler they recommended is genuinely great.",
        rating: 5,
    },
];

export const TRUST_BADGES = [
    { label: "Beginner Friendly" },
    { label: "Honest Reviews" },
    { label: "Free Resources" },
    { label: "Weekly Tips" },
];

export const TOP_PICKS = [
    {
        kind: "Best AI Tool",
        slug: "chatgpt",
        name: "ChatGPT",
        category: "Writing & Ideation",
        blurb: "Our #1 AI copilot for brainstorming, drafting and shipping faster.",
        cta: "See why",
        to: "/ai-tools#chatgpt",
        icon: "sparkles",
    },
    {
        kind: "Best Digital Tool",
        slug: "kuronazo",
        name: "KuroNazo",
        category: "Digital Tools",
        blurb: "AI-powered mystery puzzle book creator for Amazon KDP — one tool instead of five.",
        cta: "See the pick",
        to: "/affiliate#kuronazo",
        icon: "link",
    },
    {
        kind: "Best Digital Product",
        slug: "25-online-income-ideas-2026",
        name: "25 Online Income Ideas eBook",
        category: "Free Download",
        blurb: "Our own free 33-page beginner playbook — 25 real income streams with a first-90-days plan for each.",
        cta: "Download free",
        to: "/ebooks",
        icon: "book",
    },
];

export const MISSION_ITEMS = [
    { icon: "sparkles", label: "AI Tools" },
    { icon: "link", label: "Curated Picks" },
    { icon: "book", label: "Buying Guides" },
    { icon: "trending", label: "Honest Reviews" },
    { icon: "youtube", label: "Video Reviews" },
    { icon: "book", label: "Free eBooks & Resources" },
];

export const EBOOKS = [
    {
        slug: "25-online-income-ideas-2026",
        title: "25 Proven Online Income Ideas for Beginners in 2026",
        subtitle: "The lead magnet: 25 ideas you can actually start this month.",
        pages: 33,
        cover: "https://images.unsplash.com/photo-1645708759654-c90504369738?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwzfHwzZCUyMGFic3RyYWN0JTIwZ2VvbWV0cmljJTIwc2hhcGVzJTIwbW9kZXJuJTIwYXJ0fGVufDB8fHx8MTc4MzY1OTE4OHww&ixlib=rb-4.1.0&q=85",
        blurb: "25 real online income streams — AI side hustles, digital products and freelancing — each with a startup cost, effort level and first-90-day plan.",
        featured: true,
        pdf: `${process.env.REACT_APP_BACKEND_URL}/api/download/ebook/25-online-income-ideas-2026`,
    },
    {
        slug: "smart-shoppers-guide-2026",
        title: "The Smart Shopper's Guide 2026",
        subtitle: "How we pick products worth buying — and red flags to avoid.",
        pages: 28,
        cover: "https://images.unsplash.com/photo-1487017159836-4e23ece2e4cf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBtaW5pbWFsaXN0JTIwd29ya3NwYWNlJTIwbGFwdG9wJTIwZGVza3xlbnwwfHx8fDE3ODM2NTkxODd8MA&ixlib=rb-4.1.0&q=85",
        blurb: "The exact checklist we run before recommending anything — fake-review detection, price-tracking tricks, warranty traps and return-policy gotchas.",
    },
    {
        slug: "my-daily-toolkit",
        title: "My Daily Toolkit: 5 Tools I Actually Use",
        subtitle: "The short list of software that survives 6 months of daily work.",
        pages: 18,
        cover: "https://images.pexels.com/photos/33568641/pexels-photo-33568641.jpeg",
        blurb: "An honest, no-sponsor rundown of the five tools that run our entire operation — and the dozen we dropped.",
    },
];

export const AI_TOOLS = [
    {
        slug: "chatgpt",
        name: "ChatGPT",
        category: "Writing & Ideation",
        tagline: "The everyday AI copilot for creators.",
        description:
            "From drafting sales pages to brainstorming hooks — the fastest way to move from blank page to first draft.",
        rating: 4.8,
        pricing: "Freemium",
        link: "#",
    },
    {
        slug: "midjourney",
        name: "Midjourney",
        category: "Image Generation",
        tagline: "Cinematic-grade visuals from a text prompt.",
        description:
            "Beautiful product mockups, ad creatives, and thumbnails without hiring a designer.",
        rating: 4.7,
        pricing: "From $10/mo",
        link: "#",
    },
    {
        slug: "canva-ai",
        name: "Canva Magic Studio",
        category: "Design & Video",
        tagline: "Design suites with AI baked in.",
        description:
            "Templates for shorts, thumbnails, and social — with AI resize, background remove, and copy assist.",
        rating: 4.6,
        pricing: "Freemium",
        link: "#",
    },
    {
        slug: "notion-ai",
        name: "Notion AI",
        category: "Productivity",
        tagline: "A second brain that writes with you.",
        description:
            "Draft posts, summarise research, build your business wiki — all in the tool you already live in.",
        rating: 4.5,
        pricing: "$10/mo add-on",
        link: "#",
    },
    {
        slug: "elevenlabs",
        name: "ElevenLabs",
        category: "Voice",
        tagline: "Studio-grade voiceovers in seconds.",
        description:
            "Perfect for YouTube Shorts, faceless channels and audiobook side-hustles.",
        rating: 4.8,
        pricing: "Freemium",
        link: "#",
    },
    {
        slug: "descript",
        name: "Descript",
        category: "Video Editing",
        tagline: "Edit video like a text document.",
        description:
            "Auto-transcribe, cut filler words, and repurpose long videos into shorts effortlessly.",
        rating: 4.6,
        pricing: "Freemium",
        link: "#",
    },
];

export const SUPERPROFILE_URL = "https://superprofile.bio/launchtoearn";

export const AFFILIATE_PRODUCTS = [
    {
        slug: "kuronazo",
        name: "KuroNazo — Dark Mystery Puzzle Book Creator for Amazon KDP",
        category: "Digital Tools",
        price: "One-time payment",
        blurb: "The all-in-one AI software that builds complete 'find-the-killer' whodunit puzzle books for Amazon KDP — suspects, clues, solution pages, book cover and Amazon listing, all done for you. Ships with 5 difficulty tiers, up to 50,000 suspects per book, 33 colour palettes, 28 themes and step-by-step publishing training. No design skill, no monthly fees, no API keys — you own every book you make and keep 100% of the royalties. Ideal if you're exploring the KDP + printables side hustle.",
        image: "https://customer-assets.emergentagent.com/job_landing-hero-30/artifacts/cn3dm4tg_ChatGPT%20Image%20Jul%2012%2C%202026%2C%2005_33_24%20PM.png",
        link: "https://warriorplus.com/o2/a/xdkf9yh/0",
        tag: "Editor's pick",
    },
    {
        slug: "urlfam-founders-edition",
        name: "URLFAM Founders Edition — One Link. Every Tool You Need.",
        category: "Digital Tools",
        price: "Founders Edition",
        blurb: "The link-in-bio replacement built for creators who are tired of paying for five separate SaaS tools. URLFAM combines your bio link, booking calendar, digital-product storefront and email capture into a single dashboard — perfect for coaches, freelancers, YouTubers and side-hustlers. The Founders Edition is a lifetime deal (no monthly bills, no per-transaction fees), and every plan includes analytics, custom branding and unlimited links. If your Instagram / YouTube bio is doing more work than it should, this is worth a look.",
        image: "https://images.unsplash.com/photo-1645708759654-c90504369738?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwzfHwzZCUyMGFic3RyYWN0JTIwZ2VvbWV0cmljJTIwc2hhcGVzJTIwbW9kZXJuJTIwYXJ0fGVufDB8fHx8MTc4MzY1OTE4OHww&ixlib=rb-4.1.0&q=85",
        link: "https://jvz4.com/c/3601427/426095",
        tag: "All-in-one",
    },
    {
        slug: "house-of-quirk-tumbler",
        name: "House of Quirk 1200ML Stainless Steel Tumbler (Turquoise)",
        category: "Home & Kitchen",
        price: "See on Amazon",
        blurb: "A large 1.2-litre stainless-steel travel mug with an ergonomic handle, spill-proof screw lid, two reusable straws and vacuum-insulated walls that keep drinks cold for 24 hours or hot for 12. Fits in most car cup holders, gym bags and desk setups. Perfect gift for anyone who lives out of a water bottle — gym, office, hikes and long road trips. The turquoise finish is a real eye-catcher.",
        image: "https://images.unsplash.com/photo-1602143407151-7111542de6e8?w=800&q=80",
        link: "https://link.amazon/B0ckCbWcv",
    },
    {
        slug: "gopi-diary-day-out",
        name: "Gopi's Day Out — The Gopi Diaries (Sudha Murty)",
        category: "Books",
        price: "See on Amazon",
        blurb: "The next warm, funny chapter in Sudha Murty's beloved Gopi Diaries — over 3 lakh copies already sold in the series. Told from the perspective of Gopi the dog, this instalment is packed with everyday adventures, family life and gentle wisdom for young readers (age 7+). Beautifully illustrated, hardbound and a lovely gift for children, book-lovers and Sudha Murty fans.",
        image: "https://customer-assets.emergentagent.com/job_landing-hero-30/artifacts/wzyiluy6_7aaaafd8-9f7e-41dd-9415-68e3bcc58003.png",
        link: "https://link.amazon/B0g9E2VjP",
        tag: "Bestseller",
    },
    {
        slug: "ninja-blast-portable-blender",
        name: "Ninja Blast Portable Cordless Blender (BC151INNV)",
        category: "Home & Kitchen",
        price: "See on Amazon",
        blurb: "A genuine Ninja-quality blender that fits in your bag. 530 ml travel-lid jar with USB-C rechargeable battery, powerful enough to crush ice, frozen fruit and vegetables into smoothies, protein shakes and iced coffee. BPA-free, leak-proof and dishwasher-safe. Ideal for gym-goers, students, WFH desks and anyone who wants a fresh smoothie without lugging a full-sized blender.",
        image: "https://images.unsplash.com/photo-1570222094114-d054a817e56b?w=800&q=80",
        link: "https://link.amazon/B0gdohmph",
    },
    {
        slug: "ownair-standing-iron-steamer",
        name: "OWNAIR 2000W Standing Iron Steamer for Clothes",
        category: "Home & Kitchen",
        price: "See on Amazon",
        blurb: "A vertical + horizontal garment steamer + ironing station in one — 2000 W of continuous steam power, a 1.5-litre water tank, 42 g/min steam output, 8 heat modes, an LED touchscreen and a foldable ironing board. Removes wrinkles from shirts, sarees, curtains and even mattresses without setting up an ironing board. A weekend saver for anyone who hates ironing but loves crisp clothes.",
        image: "https://images.unsplash.com/photo-1485955900006-10f4d324d411?w=800&q=80",
        link: "https://link.amazon/B05TU8aYa",
    },
    {
        slug: "seznik-3in1-vacuum",
        name: "SEZNIK 3-in-1 Handheld Vacuum & Mop (SZ-V07)",
        category: "Home & Kitchen",
        price: "See on Amazon",
        blurb: "One handheld tool that vacuums, mops and picks up wet spills — 600 W motor, 20 kPa suction, 200 ml water tank and a Turbo Sweep head that switches modes in seconds. Corded (no dying battery), lightweight and made for Indian homes with tiled floors, pet hair and everyday food spills. Cleans stairs, cars and couches too.",
        image: "https://images.unsplash.com/photo-1558317374-067fb5f30001?crop=entropy&cs=srgb&fm=jpg&w=800&q=80",
        link: "https://link.amazon/B013ReLsf",
    },
    {
        slug: "swook-kindle-10-flip-case",
        name: "SwooK Magnetic Flip Cover for Kindle 10th Gen (2019)",
        category: "Accessories",
        price: "See on Amazon",
        blurb: "A slim, magnetic flip cover designed specifically for the 2019 Kindle 10th Gen (Model J9G29R — do NOT buy for the 2018 model). Auto-wake / auto-sleep works instantly, the soft interior prevents screen scratches and the printed 'Finding Joy' cover is a small joy every time you read. Lightweight enough that your Kindle still feels featherweight.",
        image: "https://images.unsplash.com/photo-1592496431122-2349e0fbc666?crop=entropy&cs=srgb&fm=jpg&w=800&q=80",
        link: "https://link.amazon/B04F7HUde",
    },
    {
        slug: "the-bounty-true-story",
        name: "The Bounty: The True Story of the Mutiny on the Bounty",
        category: "Books",
        price: "See on Amazon",
        blurb: "A meticulously researched non-fiction account of one of the most famous mutinies in maritime history — Fletcher Christian, Captain Bligh and the 1789 uprising aboard HMS Bounty. Reads like a thriller, but every word is true. Perfect for history lovers, true-crime enthusiasts and anyone who enjoys a slow-burn drama at sea.",
        image: "https://images.unsplash.com/photo-1544947950-fa07a98d237f?crop=entropy&cs=srgb&fm=jpg&w=800&q=80",
        link: "https://link.amazon/B0a7zAOar",
    },
    {
        slug: "doctor-extra-soft-mens-d544",
        name: "DOCTOR EXTRA SOFT Men's Premium Slippers (D-544)",
        category: "Footwear",
        price: "See on Amazon",
        blurb: "Soft, orthopaedic-style slippers with an acupressure sole that gently massages your feet through the day — perfect for people who stand for long hours or suffer from tired feet. Anti-skid textured base, waterproof upper, cushion memory footbed. Great for home, casual outings, monsoon puddles and gym locker rooms.",
        image: "https://images.unsplash.com/photo-1603487742131-4160ec999306?crop=entropy&cs=srgb&fm=jpg&w=800&q=80",
        link: "https://link.amazon/B08ZV6fU0",
    },
    {
        slug: "doctor-extra-soft-womens-d557",
        name: "DOCTOR EXTRA SOFT Women's EVA Flip-Flop Slippers (D-557)",
        category: "Footwear",
        price: "See on Amazon",
        blurb: "Ultra-light EVA slippers with a thick cushion platform sole that feels like walking on a cloud. Waterproof, non-slip and easy to wash — perfect for the beach, pool, kitchen, monsoon commutes and lazy Sundays at home. Available in multiple colours and true-to-size fits.",
        image: "https://images.unsplash.com/photo-1595950653106-6c9ebd614d3a?crop=entropy&cs=srgb&fm=jpg&w=800&q=80",
        link: "https://link.amazon/B0ejb91sf",
    },
];

export const DROPSHIPPING_PRODUCTS = [
    {
        slug: "posture-corrector",
        name: "Smart Posture Corrector",
        category: "Health & Fitness",
        price: "$24.90",
        margin: "3.2x",
        image: "https://images.unsplash.com/photo-1487017159836-4e23ece2e4cf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBtaW5pbWFsaXN0JTIwd29ya3NwYWNlJTIwbGFwdG9wJTIwZGVza3xlbnwwfHx8fDE3ODM2NTkxODd8MA&ixlib=rb-4.1.0&q=85",
        blurb: "High-repeat problem-solver with strong TikTok momentum.",
        link: "#",
    },
    {
        slug: "car-vacuum",
        name: "Portable Car Vacuum",
        category: "Automotive",
        price: "$34.00",
        margin: "2.6x",
        image: "https://images.pexels.com/photos/33568641/pexels-photo-33568641.jpeg",
        blurb: "Evergreen dad-gift with proven creator conversion.",
        link: "#",
    },
    {
        slug: "led-strip",
        name: "Music-Sync LED Strip",
        category: "Home",
        price: "$18.50",
        margin: "3.5x",
        image: "https://images.unsplash.com/photo-1645708759654-c90504369738?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwzfHwzZCUyMGFic3RyYWN0JTIwZ2VvbWV0cmljJTIwc2hhcGVzJTIwbW9kZXJuJTIwYXJ0fGVufDB8fHx8MTc4MzY1OTE4OHww&ixlib=rb-4.1.0&q=85",
        blurb: "A Gen-Z bedroom staple with beautiful demo footage.",
        link: "#",
    },
    {
        slug: "yoga-wheel",
        name: "Cork Yoga Wheel",
        category: "Health & Fitness",
        price: "$29.00",
        margin: "2.9x",
        image: "https://images.unsplash.com/photo-1487017159836-4e23ece2e4cf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBtaW5pbWFsaXN0JTIwd29ya3NwYWNlJTIwbGFwdG9wJTIwZGVza3xlbnwwfHx8fDE3ODM2NTkxODd8MA&ixlib=rb-4.1.0&q=85",
        blurb: "Wellness-niche product with strong bundle potential.",
        link: "#",
    },
    {
        slug: "pet-brush",
        name: "Self-Cleaning Pet Brush",
        category: "Pets",
        price: "$21.90",
        margin: "3.1x",
        image: "https://images.pexels.com/photos/33568641/pexels-photo-33568641.jpeg",
        blurb: "Emotion-led product with easy UGC angles.",
        link: "#",
    },
    {
        slug: "kitchen-scale",
        name: "Minimalist Kitchen Scale",
        category: "Home",
        price: "$27.00",
        margin: "2.4x",
        image: "https://images.unsplash.com/photo-1645708759654-c90504369738?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwzfHwzZCUyMGFic3RyYWN0JTIwZ2VvbWV0cmljJTIwc2hhcGVzJTIwbW9kZXJuJTIwYXJ0fGVufDB8fHx8MTc4MzY1OTE4OHww&ixlib=rb-4.1.0&q=85",
        blurb: "Design-led niche staple — perfect for lifestyle stores.",
        link: "#",
    },
];

export const CATEGORIES = ["All", "Health & Fitness", "Home", "Pets", "Automotive"];

export const SHORTS = [
    { id: "dQw4w9WgXcQ", title: "3 AI tools worth paying for in 2026" },
    { id: "9bZkp7q19f0", title: "This ₹499 tumbler outperforms ₹2,000 bottles" },
    { id: "3JZ_D3ELwOQ", title: "How to spot fake Amazon reviews in 10 seconds" },
    { id: "kJQP7kiw5Fk", title: "5 things to check before you hit Buy Now" },
    { id: "hT_nvWreIhg", title: "My honest review: the gadget everyone is buying" },
    { id: "OPf0YbXqDm0", title: "The productivity app I open 8 hours a day" },
    { id: "L_jWHffIx5E", title: "Amazon vs Flipkart — same product, real comparison" },
    { id: "fJ9rUzIMcZQ", title: "3 shopping tricks that save you ₹500 every order" },
];

export const BLOG_POSTS = [
    {
        slug: "honest-reviews-vs-paid-reviews",
        title: "Honest Reviews vs Paid Reviews: How to Tell the Difference in 2026",
        excerpt:
            "Most product reviews online are bought. Here's the 6-signal checklist we run before trusting any recommendation - ours included.",
        cover: "https://images.unsplash.com/photo-1556155092-490a1ba16284?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
        category: "Buying Guides",
        readingTime: 7,
        date: "Feb 3, 2026",
        content:
            "Roughly 30% of online reviews are fake, and a much bigger slice are \"soft-bought\" - the reviewer got a free sample or a referral fee and never told you. After testing products for a living, we've learned to spot the tells in seconds. Here they are, so you never get burned.\n\n### 1. Look at the language, not the stars\nFake and paid reviews are vague: \"Amazing product, works great, highly recommended!\". Real reviews mention specifics - the weight of the bottle, the exact colour mismatch, the one button that feels cheap. If a review could be pasted under any product, it probably was.\n\n### 2. Check the date pattern\nGo to a product's review page and sort by date. If 40 five-star reviews all landed in the same week, the seller bought a review batch. Real reviews trickle in unevenly over months.\n\n### 3. Watch for the same photo used twice\nReverse-image search (Google Lens) the review photos. Review farms reuse stock photos across dozens of listings. Real buyers take bad photos of their actual kitchen counter.\n\n### 4. Disclosure is a good sign, not a bad one\nA reviewer who says \"I bought this myself\" or clearly discloses a partner link is usually more honest than one pretending to have no stake at all. Zero disclosure + glowing praise + a link is the worst combination.\n\n### 5. The 3.5-star test\nNobody's favourite product is a 5-star product. The most trustworthy reviewers complain about something - the packaging, the delivery time, the missing USB-C cable. A review with zero criticism is marketing, not a review.\n\n### 6. Cross-check two \"worst\" reviews\nRead the 1-star and 2-star reviews first. If they all complain about the same thing (battery dies in 3 months, stitching comes apart), that's real data. If they're about delivery delays and packaging, the product itself is probably fine.\n\n### How this applies to us\nOn AllAboutYouBuy we only recommend products we've handled ourselves or vetted hard. When a link earns us a referral reward, it's disclosed. You should hold us to the same six signals - if we ever fail them, tell us and we'll fix it.",
    },
    {
        slug: "amazon-india-shopping-checklist",
        title: "Amazon India Shopping Checklist: 12 Things to Check Before You Hit 'Buy Now'",
        excerpt:
            "From seller ratings to hidden price history - the 12-step checklist that has saved us (and our readers) thousands of rupees.",
        cover: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
        category: "Buying Guides",
        readingTime: 6,
        date: "Jan 27, 2026",
        content:
            "Amazon India is the default for most online shopping - but the platform is a maze of third-party sellers, fake discounts and bait listings. Run this 12-step checklist before every purchase and you'll dodge 95% of buyer's remorse.\n\n### Before you open the product page\n\n**1. Search the exact product name on Google first.** Often the same item is cheaper on Flipkart, Meesho or the brand's own site.\n\n**2. Check the price history.** Install a free tracker (like PriceBefore or Keepa). If the \"70% off\" price is actually the normal price, you'll see it instantly.\n\n### On the product page\n\n**3. Read the seller name, not just the rating.** Tap \"Sold by\" - you want sellers with 90%+ ratings and at least a few thousand ratings. \"Just Launched\" sellers are a gamble.\n\n**4. Sort reviews by \"Most recent\".** The default sort shows the seller's favourite reviews. Recent reviews tell you what the product is like *this month*, after batches change.\n\n**5. Read the 1-star reviews first.** Ignore delivery complaints - focus on product complaints. If three different people mention the same defect, it's real.\n\n**6. Check the \"Customer questions\" section.** Real owners answer real questions here, often more honestly than in reviews.\n\n**7. Zoom into the photos.** If the listing uses heavily rendered images with no real-life photos, be suspicious. Real products get photographed by real buyers.\n\n**8. Verify the exact model number.** Sellers often list older models with a newer product's photos. Match the model code on the box image to the manufacturer's website.\n\n### Before you pay\n\n**9. Check the return window.** Standard is 7-10 days. \"Non-returnable\" on a product you've never tried is a red flag.\n\n**10. Compare \"Amazon Fulfilled\" vs regular.** Fulfilled items ship faster and have cleaner return handling.\n\n**11. Look for the bank/card offer.** Most credit cards give 5-10% instant discount - that's real money, not the fake MRP strikethrough.\n\n**12. Screenshot the listing.** If the product arrives different from what was shown, the screenshot is your evidence for a return.\n\n### The 60-second version\nCheck seller rating, read recent 1-star reviews, verify the price history, confirm the return window. Four steps, sixty seconds, thousands of rupees saved.",
    },
    {
        slug: "5-things-worth-buying-on-amazon",
        title: "5 Things Actually Worth Buying on Amazon India (And 5 That Aren't)",
        excerpt:
            "A buyer's honest split list: the categories where Amazon consistently delivers value, and the ones where you should shop elsewhere.",
        cover: "https://images.unsplash.com/photo-1523275335684-37898b6baf30?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
        category: "Picks",
        readingTime: 6,
        date: "Jan 20, 2026",
        content:
            "After a year of ordering basically everything on Amazon India, a pattern emerged. Some categories consistently deliver great value; others are better bought offline or elsewhere. Here's the honest split.\n\n### Worth buying on Amazon\n\n**1. Books.** Prices are routinely 30-40% below MRP, returns are painless, and originals are almost guaranteed. The Gopi Diaries series we recommend is a perfect example.\n\n**2. Kitchen gadgets and home organisers.** The tumbler, blender and vacuum on our Picks page all live here - the review volume is huge, so bad products get exposed fast.\n\n**3. Kindle devices and accessories.** Amazon makes the Kindle, so pricing and warranty are unbeatable.\n\n**4. Everyday essentials in bulk.** Tissues, detergent, coffee, pet food - Subscribe & Save quietly undercuts the neighbourhood shop.\n\n**5. Branded small appliances.** Philips, Ninja, Havells - official storefronts with proper warranty, often cheaper than brand stores.\n\n### Better bought elsewhere\n\n**1. Clothing (except basics).** Sizing is a lottery and return pickups get rejected. Shop in-store or from the brand's own site.\n\n**2. Jewellery and watches.** Too many counterfeit listings even from \"fulfilled\" sellers. Buy from authorised retailers.\n\n**3. Furniture.** Delivery damage rates are high and returns are painful. Local stores will negotiate and deliver assembled.\n\n**4. Fresh groceries.** Amazon Fresh quality varies wildly by city. Local vendors or quick-commerce apps do it better.\n\n**5. High-end electronics.** Compare with Croma/Reliance first - their card offers often beat Amazon, and installation support is better.\n\n### The rule of thumb\nIf a product is standardised (a book is a book, a blender is a blender), Amazon wins. If fit, feel or freshness matters, shop somewhere you can touch it first.",
    },
    {
        slug: "5-ai-tools-worth-paying-for",
        title: "5 AI Tools Actually Worth Paying For in 2026",
        excerpt:
            "Most AI subscriptions are noise. These five survived six months of daily use and still earn their monthly fee.",
        cover: "https://images.unsplash.com/photo-1677442136019-21780ecad995?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
        category: "AI Tools",
        readingTime: 7,
        date: "Jan 12, 2026",
        content:
            "Every week there are 40 new \"AI tools you need\". Most are thin wrappers around ChatGPT with a nicer landing page. After six months of daily testing, exactly five tools still earn their subscription. Here's the honest list.\n\n### 1. ChatGPT Plus (~INR 1,700/mo)\nStill the workhorse. Drafting, brainstorming, rewriting, summarising - nothing else matches its consistency. The paid tier's memory feature alone saves an hour a week: train it on your preferences once and it stays in character.\n\n**Skip if:** you only need it a few times a month - the free tier is fine.\n\n### 2. Canva Pro (~INR 500/mo)\nThe AI features (Magic Resize, background remover, text-to-image) turned a good design tool into a complete content studio. Every thumbnail, cover and social post we make goes through it.\n\n**Skip if:** you already have a designer.\n\n### 3. Perplexity Pro (~INR 1,700/mo)\nGoogle replacement for research. It cites sources live, which makes fact-checking dramatically faster. The free tier covers casual use; Pro matters if you research daily.\n\n### 4. Descript (~INR 1,000/mo)\nEdit video by editing text. Record, transcribe, delete the ums from the transcript, and the video edits itself. If you make Reels or Shorts, this pays for itself in week one.\n\n### 5. Notion AI (~INR 800/mo)\nNotes, planning and AI drafting in one place. The killer feature is asking questions across your own notes - your second brain that actually answers back.\n\n### What we cancelled\nJasper, Copy.ai, Writesonic and a dozen \"AI schedulers\" - all did the same job worse than the five above. When in doubt, count how many subscriptions you're paying for AI you don't actually open.\n\n### The rule\nPay only for tools you opened at least five times last week. Everything else is hype with a billing page.",
    },
];

export const FAQS = [
    {
        q: "Is AllAboutYouBuy free?",
        a: "Everything on this site — guides, product picks, ebooks — is free to read and use. When you buy through some of our partner links, the store pays us a small referral reward at no extra cost to you.",
    },
    {
        q: "Do I need any experience to start?",
        a: "Not at all. Every playbook we publish assumes you're starting from zero. We link to beginner-friendly tools and only recommend what we'd hand to a friend.",
    },
    {
        q: "How do you pick the products you recommend?",
        a: "We only recommend products we use ourselves or have vetted through hands-on testing. No pay-to-play placements.",
    },
    {
        q: "Do you offer coaching or 1:1 support?",
        a: "Not right now. We focus on scalable content — free guides, ebooks, and a weekly newsletter — that gets you results without needing to hire us.",
    },
    {
        q: "How often is content updated?",
        a: "We publish 1–2 new posts per week and refresh existing guides monthly to keep everything current with the ecosystem.",
    },
    {
        q: "Can I republish or translate your content?",
        a: "Reach out via the contact form. We're open to attributed republishing and community translations.",
    },
];
